import { ApiError, PaginatedCollection } from '@/api/types'
import { SortDirection } from '@/entities/sort'
import { PaidWithdrawModel } from '../../model'
import { getColumnsPending } from '../../table'
import { MobileBlockTraderWithdraw } from '../mobile/mobileBlocks/MobileBlockTraderWithdraw'
import { BaseTable, BaseTableSkeleton } from 'syncra-storybook/features'

export const AssignedPanel = ({
  assignedData,
  assignedError,
  isAssignedDataLoading,
  loadingAssignedIds,
  methods,
  skip,
  sort,
  toggleSort,
  isAll=false
}: {
  assignedData: PaginatedCollection<PaidWithdrawModel[]> | undefined
  assignedError: ApiError | null
  isAssignedDataLoading: boolean
  methods: {
    acceptWithdraw: (id: string) => void
    handlePageChange: (newSkip: number) => void
  }
  loadingAssignedIds: string[]
  skip?: number
  sort?: {
    sortCreatedAt?: SortDirection
    sortAmountTo?: SortDirection
    sortAllowedAt?: SortDirection
  }
  toggleSort?: (key: 'sortCreatedAt' | 'sortAmountTo'| 'sortAllowedAt') => void
  isAll?:boolean
}) => {
  return (
    <div className="mt-8">
      {assignedError ? (
        <p>Ошибка загрузки данных.</p>
      ) : isAssignedDataLoading ? (
        <BaseTableSkeleton />
      ) : !assignedData?.items || assignedData.items?.length === 0 ? (
        <p>Исходящих заявок нет.</p>
      ) : (
        <BaseTable
          columns={getColumnsPending({
            onAction: methods.acceptWithdraw,
            loadingIds: loadingAssignedIds,
            sort,
            toggleSort,
            isAll
          })}
          data={assignedData.items}
          cardClasses="border-0"
          onPageChange={methods.handlePageChange}
          skip={skip}
          totalItems={assignedData.count}
          mobileCards={assignedData.items.map((el) => (
            <MobileBlockTraderWithdraw
              key={el.id}
              withdraw={el}
              onAction={() => methods.acceptWithdraw(el.id)}
            />
          ))}
        />
      )}
    </div>
  )
}
